import appInfoGet from './appInfoGet';
import appInfoQuery from './appInfoQuery';
import appInfoQueryNoPage from './appInfoQueryNoPage';
import getPermissions from './getPermissions';
import autoRefresh from './autoRefresh';
export default {
    appInfoGet,
    appInfoQuery,
    appInfoQueryNoPage,
    getPermissions,
    autoRefresh
};


// WEBPACK FOOTER //
// ./src/api/appInfo/index.ts